import React from "react";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../App";
import { useNavigate } from "react-router-dom";
import FoundItem from "../../components/foundItem/foundItem";
import Swal from "sweetalert2";
import {
  InputGroup,
  FormControl,
  Button,
  Container,
  Form,
} from "react-bootstrap";
import Error from "../error/error";
import { postUserProduct, findProduct, getUserProduct } from "../../utils/api";
import "./handAdding.css";
import "./../../components/button/button.css";
import { authentication } from "../../utils/config";
import Banner from "./../../components/banner/banner";
import ImageQrcode from "../../assets/qrcode.png";

const HandAdding = () => {
  const navigate = useNavigate();
  const [cardData, setCardData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [newProduct, setNewProduct] = useState({
    productCode: "",
    type: "",
    model: "",
  });
  //line certify
  const lineProfile = useContext(AuthContext);

  // check account
  useEffect(() => {
    let flag = true;
    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (
        response.data === "no user" ||
        response.data === "no vertification"
      )
        return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");

      flag = false;
    };

    //call getUserProduct api
    const fetchUserProduct = async () => {
      if (flag) return;
      const response = await getUserProduct(lineProfile);
      if (response.error) {
        await Swal.fire({
          title: "系統錯誤",
          text: JSON.stringify(response.data),
          icon: "error",
        });
      } else if (response.data === "not found the user") {
        await Swal.fire({
          title: "帳號不存在",
          text: "請註冊帳號",
          icon: "error",
        });
      } else if (response.data === "not found any product") {
        setCardData([]);
      } else {
        const fetchData = response.data.map((data) => data.product.code);
        setCardData(fetchData);
      }
    };
    const combine = async () => {
      await auth();
      await fetchUserProduct();
    };
    combine();
  }, []);

  //onclick + event
  const [inputData, setInputData] = useState("");
  const handleChange = (e) => {
    const { value } = e.target;
    setInputData(value);
    console.log(inputData) ;
  };

  const handlePlusSubmit = async (event) => {
    event.preventDefault();
    
    const response = await findProduct(lineProfile, inputData);

    if (response.error) {
      await Swal.fire({
        title: "系統錯誤",
        text: JSON.stringify(response.data),
        icon: "error",
      });
    } else if (response.data === "not found the product") {
      await Swal.fire({
        title: "商品編號錯誤",
        text: "請重新輸入或連繫客服",
        icon: "error",
      });
    } else {
      setNewProduct((preData) => ({
        ...preData,
        productCode: response.data.code,
        type: response.data.typeModel.type,
        model: response.data.typeModel.model,
      }));
      setShowModal(true);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleModalSubmit = async () => {
    const response = await postUserProduct(lineProfile, inputData);
    if (response.error) {
      await Swal.fire({
        title: "系統錯誤",
        text: JSON.stringify(response.data),
        icon: "error",
      });
    } else if (response.data === "not found the user") {
      await Swal.fire({
        title: "帳號不存在",
        text: "請註冊帳號",
        icon: "error",
      });
    } else if (response.data === "not found the product") {
      await Swal.fire({
        title: "商品不存在",
        text: "請重新輸入或掃描商品編號",
        icon: "error",
      });
    } else if (
      response.data === "have already registered the product with approvement"
    ) {
      await Swal.fire({
        title: "您已登錄此產品",
        icon: "warning",
      });
    } else {
      if (
        response.data.approvement === false ||
        response.data ===
          "have already registered the product without approvement"
      ) {
        await Swal.fire({
          title: "此產品已被登入",
          text: "請聯繫客服",
          icon: "question",
        });
      } else {
        await Swal.fire({
          title: "商品已加入",
          icon: "success",
        });
        setInputData("") ;
        setCardData((prevData) => [
          ...(prevData || []),
          response.data.productCode,
        ]);
      }
      
    }
    
  };

  return (
    <Container className="p-0">
      <div
        fluid
        className="vh-100 d-flex flex-column"
        style={{ backgroundColor: "#E4F4F3", minHeight: "100vh" }}
      >
        <div style={{ height: "12%", width: "100%" }}>
          <Banner />
        </div>
        <div style={{ height: "60%" }}>
          <div
            className="mx-auto text-left mt-5"
            style={{ width: "70%", paddingLeft: "2",  marginBottom: "10px" }}
          >
            <b> 產品機器號碼登入</b>
          </div>
          <div
            className="d-flex align-items-start justify-content-center mx-auto"
            style={{ width: "70%" }}
          >
              <InputGroup
                className=" square-item my-auto mx-0"
                style={{ backgroundColor: "transparent" }}
              >
                <FormControl
                  placeholder="英+數9-16碼"
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                  required={true}
                  value={inputData}
                  onChange={handleChange}
                />
                <Button
                  style={{ backgroundColor: "#80CDC7", border: "none" }}
                  onClick={handlePlusSubmit}
                >
                  +
                </Button>
              </InputGroup>
          </div>
          {!cardData && (
            <p className="text-center">
              <b>目前尚未登入任何型號</b>
            </p>
          )}
          {cardData && (
            <>
              <div
                className="mx-auto text-left mt-5"
                style={{ width: "70%", paddingLeft: "0" }}
              >
                <b>已加入產品</b>
              </div>
              <div
                className="card-data-container"
                style={{
                  maxHeight: "27vh",
                  overflowY: "auto",
                }}
              >
                {cardData.map((data, index) => (
                  <div key={index} className="square-item">
                    {data}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        <div className="text-center">
          <p className="fs-5" style={{ color: "#999C9C" }}>
            <u
              onClick={() => {
                navigate("/codePlace");
              }}
            >
              <b>機器號碼位置</b>
            </u>
          </p>
          <Button
            variant="#56ACAE"
            type="submit"
            className="w-50 btn-custom-green"
            onClick={() => {
              navigate("/memberRecord");
            }}
          >
            <b>查看產品細節</b>
          </Button>
        </div>
        <div className="text-center m-3 fs-5" style={{ color: "#47A8A3" }}>
          <b
            onClick={() => {
              navigate("/main");
            }}
          >
            結束登入產品
          </b>
        </div>
      </div>
      {showModal && (
        <FoundItem
          handleClose={handleModalClose}
          productCode={newProduct.productCode}
          type={newProduct.type}
          model={newProduct.model}
          api={handleModalSubmit}
        />
      )}
    </Container>
  );
};

export default HandAdding;
